import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function MidPageCTA() {
  const scrollToOffer = () => {
    const target = document.getElementById('offer');
    if (!target) return;
    const targetPosition = target.getBoundingClientRect().top + window.scrollY;
    const startPosition = window.scrollY;
    const distance = targetPosition - startPosition;
    const duration = 2000;
    let startTime: number | null = null;
    function animation(currentTime: number) {
      if (startTime === null) startTime = currentTime;
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const ease = progress < 0.5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2;
      window.scrollTo(0, startPosition + distance * ease);
      if (progress < 1) {
        requestAnimationFrame(animation);
      }
    }
    requestAnimationFrame(animation);
  };
  return <Section background="accent" className="relative overflow-hidden border-y border-slate-800" data-id="element-138">
      <div className="absolute inset-0 bg-brand-orange/5" data-id="element-139"></div>
      <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8 max-w-5xl mx-auto" data-id="element-140">
        <div className="text-center md:text-left" data-id="element-141">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-white uppercase mb-2" data-id="element-142">
            Ready to Stop the{' '}
            <span className="text-brand-orange" data-id="element-143">Knee Tax?</span>
          </h2>
          <p className="text-slate-400 text-sm md:text-base" data-id="element-144">
            Join 2,800+ men who are pain-free and leaner than ever.
          </p>
        </div>

        <div className="flex flex-col items-center gap-3" data-id="element-145">
          <Button size="lg" onClick={scrollToOffer} className="whitespace-nowrap shadow-lg shadow-brand-orange/20" data-id="element-146">
            Get The Blueprint — $6.36 <ArrowRight className="ml-2 w-5 h-5" data-id="element-147" />
          </Button>
          <span className="text-xs text-slate-500 uppercase tracking-wider" data-id="element-148">
            30-Day Money-Back Guarantee
          </span>
        </div>
      </div>
    </Section>;
}